import React from 'react';
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../styles/side-bar.module.scss";
import {SideBarModuleTab} from "./side-bar-module.tab";

export const SideBarModuleTabs = observer(({controller}) => {
  const {state} = controller
  const {entityScoresTabs} = state

  return (
    <div className={classNames(styles.tabs)}>
      {
        entityScoresTabs.map(tab => <SideBarModuleTab
          tab={tab}
          key={tab.index}
          controller={controller}
        />)
      }
    </div>
  )
})
